import React from 'react';
import { css } from 'emotion';
import { ElementRoot } from '@whalecloud/page-builder-core/components/ElementRoot';
import { Tree as DesignTree } from '@whalecloud/fdx';
import FormItem from "@whalecloud/page-builder-core/components/Render/components/FormItem";
import { makeEventProps } from '@whalecloud/page-builder-core/utils/common';

const left = css({ textAlign: 'left' });
const Tree = props => {
  const { element, nameSpace } = props;
  const { formItemSettings, formSettings, settings, className = '' } = element.data;
  const { horizontalAlign = 'left' } = settings;
  const { treeData, autoInitialize } = formItemSettings;
  const eventProps = makeEventProps(element.data.events, nameSpace);
  return (
    <ElementRoot className={'webiny-pb-base-page-element-style'} element={element}>
      {({ getAllClasses, elementStyle }) => (
        <div style={{ textAlign: horizontalAlign }}>
          <FormItem
            id={element.id}
            style={elementStyle}
            className={getAllClasses('webiny-pb-base-page-element-style', 'webiny-pb-page-element-input', left)}
            {...formSettings}
          >
            <DesignTree style={elementStyle} {...formItemSettings} className={className} treeData={autoInitialize ? treeData : []} {...eventProps} />
          </FormItem>
        </div>
      )}
    </ElementRoot>
  );
};

export default Tree;
